module.exports = __webpack_public_path__ + "img/one-step.bfff2194.png";